import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SignIn from '../views/SignIn'
import Settings from '../views/Settings'

import Administration from '../views/Administration.vue'
import BirdLookup from '../views/BirdLookup.vue'
import Reports from '../views/Reports/Reports.vue'
import EggGroups from '../views/EggGroups.vue'
import VisionCollection from '../views/VisionCollection.vue'
import EggCollection from '../views/EggCollection.vue'
import LocalStorage from '../views/LocalStorage.vue'
import DocumentList from '../views/DocumentList.vue'
import PdfDocument from '../views/PdfDocument.vue'
import EggSummaryReport from '../views/Reports/EggSummaryReport.vue'
import EggDailyReport from '../views/Reports/EggDailyReport.vue'
import EggGroupReport from '../views/Reports/EggGroupReport.vue'
import ScanCodes from '../views/ScanCodes.vue'

// EggVision Camera Capture Views
import SummaryView from '../views/SummaryView.vue'
import VisionGroups from '../views/VisionGroups.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/index.html',
    name: 'index',
    component: Home
  },
  {
    path: '/eggGroups',
    name: 'Egg Collection Groups',
    component: EggGroups
  },
  {
    path: '/eggVision',
    name: 'Egg Vision Groups',
    component: VisionGroups
  },
  {
    path: '/egg-vision/capture',
    name: 'Egg Vision',
    component: VisionCollection
  },
  {
    path: '/egg-vision/summary',
    name: 'EggVision Summary',
    component: SummaryView
  },
  {
    path: '/administration',
    name: 'Administration',
    component: Administration
  },
  {
    path: '/birdLookup',
    name: 'Bird Lookup',
    component: BirdLookup
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports
  },
  {
    path: '/reports/EggDailyReport',
    name: 'Egg Daily Report',
    component: EggDailyReport
  },
  {
    path: '/reports/EggSummaryReport',
    name: 'Egg Summary Report',
    component: EggSummaryReport
  },
  {
    path: '/reports/EggGroupReport',
    name: 'Egg Group Report',
    component: EggGroupReport
  },
  {
    path: '/eggCollection',
    name: 'Egg Collection',
    component: EggCollection
  },
  {
    path: '/localstorage',
    name: 'Local Storage',
    component: LocalStorage
  },
  {
    path: '/documents',
    name: 'Documents',
    component: DocumentList
  },
  {
    path: '/pdfDocument',
    name: 'Document',
    component: PdfDocument
  },
  {
    path: '/scanCodes',
    name: 'Scan Codes',
    component: ScanCodes
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
})

export default router